// =============================================================================
// CMA History Routes  —  /cma-history
// =============================================================================
// Route registration for the CMA history page.
// AuthGuard redirects unauthenticated users to sign-in.
//
// Related files:
//   src/pages/cma/cma-history.tsx         → page wrapper
//   src/routes/paths.ts                   → paths.cmaHistory.root
// =============================================================================

import type { RouteObject } from 'react-router';

import { lazy, Suspense } from 'react';

import { CONFIG } from 'src/global-config';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

const CmaHistoryPage = lazy(() => import('../../pages/cma/cma-history'));

// ----------------------------------------------------------------------

export const cmaHistoryRoutes: RouteObject[] = [
  {
    path: 'cma-history',
    element: CONFIG.auth.skip ? (
      <Suspense fallback={<LoadingScreen />}>
        <DashboardLayout>
          <CmaHistoryPage />
        </DashboardLayout>
      </Suspense>
    ) : (
      <AuthGuard>
        <Suspense fallback={<LoadingScreen />}>
          <DashboardLayout>
            <CmaHistoryPage />
          </DashboardLayout>
        </Suspense>
      </AuthGuard>
    ),
  },
];
